import { useMemo, memo } from "react";
import { useInterval } from "react-use";
import useSearchFilter from "modules/hooks/use-search-filter";
import { SearchFilterType } from "gql/graphql";
import { DATE_RANGE_TYPE } from "modules/utils/Constants";

const DateFilterUpdateListener = () => {
  const TIMEOUT_MS = 1000 * 5; // check this every 5 seconds
  const { getSearchFilter, getStartDate, addOrReplaceFilters } =
    useSearchFilter();

  const dateRangeFilter = useMemo(
    () => getSearchFilter(SearchFilterType.DateRangeType),
    [getSearchFilter],
  );

  useInterval(() => {
    if (!dateRangeFilter) return;

    const startDate = getSearchFilter(SearchFilterType.StartDate)?.instantValue;

    if (
      dateRangeFilter.stringValue === DATE_RANGE_TYPE.LAST_24_HOURS &&
      startDate !== getStartDate(DATE_RANGE_TYPE.LAST_24_HOURS)
    ) {
      addOrReplaceFilters([
        {
          type: SearchFilterType.StartDate,
          instantValue: getStartDate(DATE_RANGE_TYPE.LAST_24_HOURS),
        },
      ]);
    }
    if (
      dateRangeFilter.stringValue === DATE_RANGE_TYPE.LAST_7_DAYS &&
      startDate !== getStartDate(DATE_RANGE_TYPE.LAST_7_DAYS)
    ) {
      addOrReplaceFilters([
        {
          type: SearchFilterType.StartDate,
          instantValue: getStartDate(DATE_RANGE_TYPE.LAST_7_DAYS),
        },
      ]);
    }
    if (
      dateRangeFilter.stringValue === DATE_RANGE_TYPE.LAST_30_DAYS &&
      startDate !== getStartDate(DATE_RANGE_TYPE.LAST_30_DAYS)
    ) {
      addOrReplaceFilters([
        {
          type: SearchFilterType.StartDate,
          instantValue: getStartDate(DATE_RANGE_TYPE.LAST_30_DAYS),
        },
      ]);
    }
  }, TIMEOUT_MS);

  return null;
};

export default memo(DateFilterUpdateListener);
